import { render } from "./AdditionalUser.vue?vue&type=template&id=7bb1ebcf"
const script = {}
script.render = render

export default script